import React from "react";
import { Card } from "../onboarding/adminUi";
import { WEEKDAYS } from "./MacroTable";

export const WeekGrid = ({ weeks, setWeeks, types, planWeeks, locked }) => {
  const setDay = (wi, wd, v) => setWeeks(weeks.map((w) => (w.index !== wi ? w : { ...w, days: w.days.map((x) => (x.weekday === wd ? { ...x, day_type: v } : x)) })));
  return (
    <Card title="Tipo de día asignado a cada jornada" testid="pr-nutrition-weeks">
      <div style={{ fontSize: 12, color: "#a3a3a3", marginBottom: 10 }}>Propuesto por la IA según el contenido de cada sesión. Debajo de cada día ves la sesión física de ese día.</div>
      <div style={{ overflowX: "auto" }}>
        {weeks.map((w) => {
          const pw = (planWeeks || []).find((p) => p.index === w.index);
          return (
            <div key={w.index} style={{ marginBottom: 14, minWidth: 760 }} data-testid={`pr-nutrition-week-${w.index}`}>
              <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>{w.label || pw?.label || `Semana ${w.index + 1}`}</div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 6 }}>
                {w.days.map((x) => {
                  const s = pw?.days.find((p) => p.weekday === x.weekday);
                  return (
                    <div key={x.weekday} style={{ fontSize: 11 }}>
                      <div style={{ color: "#737373", marginBottom: 3 }}>{WEEKDAYS[x.weekday]}</div>
                      <select className="qv-input" disabled={locked} value={x.day_type} onChange={(e) => setDay(w.index, x.weekday, e.target.value)} title={x.reason || ""}
                        style={{ padding: "4px 6px", fontSize: 11, textTransform: "none" }} data-testid={`pr-nutrition-day-${w.index}-${x.weekday}`}>
                        {types.map((t) => <option key={t.key} value={t.key}>{t.label}</option>)}
                        {!types.some((t) => t.key === x.day_type) && <option value={x.day_type}>{x.day_type} (eliminado)</option>}
                      </select>
                      <div style={{ color: "#a3a3a3", marginTop: 3, minHeight: 14 }}>{s ? s.title || s.day_type : "—"}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
};
